import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * React Router v6 does not restore or reset scroll position on navigation.
 * Without this, opening a collage from halfway down the grid lands you
 * halfway down the collage page, and going back lands you at the top of
 * the grid instead of where you were.
 *
 * Forward navigation (PUSH) resets to the top; browser back/forward (POP)
 * is left alone so the browser's own restoration can do its job.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType === 'POP') return;
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;
